import { Outlet } from "react-router-dom";
import { AuthProvider } from "../lib/auth";
import { Navigation } from "./layout/Navigation";

/**
 * Root component that provides auth context and layout structure
 * Handles the overall application layout with navigation and content area
 */
export default function Root() {
  return (
    <AuthProvider>
      <div className="min-h-screen bg-[#030014] text-white">
        <Navigation />
        {/* Add margin-top on mobile for the header, and left margin on desktop for the sidebar */}
        <main className="mt-14 lg:mt-0 lg:ml-48 min-h-screen relative z-0">
          {/* Aurora Background Effect */}
          <div className="absolute inset-0 overflow-hidden -z-10">
            <div className="absolute -inset-[10px] opacity-20">
              <div className="absolute top-0 -right-4 w-96 h-96 bg-purple-500 rounded-full mix-blend-multiply filter blur-xl opacity-50 animate-blob" />
              <div className="absolute bottom-0 -left-4 w-96 h-96 bg-cyan-500 rounded-full mix-blend-multiply filter blur-xl opacity-50 animate-blob delay-[2s]" />
            </div>
          </div>
          
          {/* Content Area */}
          <div className="max-w-7xl mx-auto px-4 py-8 relative z-10">
            <div className="backdrop-blur-sm bg-[#030014]/80 border border-white/10 rounded-2xl p-6 shadow-xl relative z-20">
              <Outlet />
            </div>
          </div>
        </main>
      </div>
    </AuthProvider>
  );
}
